import React, { useState } from 'react';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import FormTemplate, { THEMES } from '@/components/formTemplate/index';
import { BILLING_ADDRESS } from '@/constants/billingAddress';
import Address from '@/containers/address';
import { useSelector } from 'react-redux';
import SmartAppointment from '@/containers/smartAppointment';
import { SMART_APPOINTMENT } from '@/constants/smartAppointment';
import { INSTALLATION_ADDRESS } from '@/constants/installationAddress';
import { useWatch } from 'react-hook-form';

function ClientAddress({
  control,
  unregister,
  resetField,
  getValues,
  address = '',
  addressFormStructure = BILLING_ADDRESS,
  addressAction = null,
  editable = true,
  setValue = null,
  withAppointment = true,
}) {
  const appointmentData = useSelector((state) => state.appointment);
  const loadingShoppingCart = useSelector(
    (state) => state.formBaf.loadingShoppingCart
  );
  const horizontalAddress = useWatch({
    control,
    name: INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID,
  });
  const verticalAddress = useWatch({
    control,
    name: INSTALLATION_ADDRESS.VERTICAL_ADDRESS.ID,
  });
  const manualAddressChecked = useWatch({
    control,
    name: INSTALLATION_ADDRESS.MANUAL_ADDRESS_CHECKBOX.ID,
  });
  const automaticAddress =
    !manualAddressChecked && (horizontalAddress?.full || verticalAddress?.full);
  const {
    firstAvailableAppointment,
    appointmentOptions,
    getExtraAppointmentLoading,
    appointmentText,
    manualAppointmentText,
  } = { ...appointmentData };
  const [isEditable, setIsEditable] = useState(!address);
  const handleEditAction = () => {
    setIsEditable(true);
  };
  const loadingAppointment =
    (loadingShoppingCart && isEditable) ||
    (getExtraAppointmentLoading && !isEditable);
  return (
    <>
      {!isEditable && (
        <div className="client-address-container">
          <FormTemplate
            titleText={addressFormStructure.TITLE}
            cyData={addressFormStructure.ID}
            theme={THEMES.LONG}
            action={
              editable
                ? {
                    onClick: handleEditAction,
                    label: 'Editar',
                  }
                : null
            }
          >
            <Text
              text={address}
              color={TEXT_COLOR.GREY5}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </FormTemplate>
        </div>
      )}
      {isEditable && (
        <Address
          unregister={unregister}
          control={control}
          getValues={getValues}
          resetField={resetField}
          formStructure={addressFormStructure}
          componentName={addressFormStructure.ID}
          setInfo={addressAction}
          setValue={setValue}
        />
      )}
      {withAppointment && (
        <SmartAppointment
          control={control}
          firstAvailableAppointment={
            (automaticAddress || !isEditable) && firstAvailableAppointment
              ? firstAvailableAppointment
              : null
          }
          appointmentOptions={
            (automaticAddress || !isEditable) && firstAvailableAppointment
              ? appointmentOptions
              : null
          }
          title={
            (!firstAvailableAppointment || manualAddressChecked) &&
            !loadingAppointment
              ? SMART_APPOINTMENT.TITLE_MANUAL_APPOINTMENT
              : null
          }
          loading={loadingAppointment}
          unregister={unregister}
          info={
            !manualAddressChecked &&
            (automaticAddress || !isEditable) &&
            !firstAvailableAppointment &&
            !loadingAppointment
              ? appointmentText
              : manualAddressChecked && manualAppointmentText
          }
        />
      )}
      <style jsx>
        {`
          .client-address-container {
            margin-bottom: 12px;
          }
        `}
      </style>
    </>
  );
}
export default ClientAddress;
